import React from "react";

interface RapperTabsProps {
  tabs: Array<{
    id: string;
    label: string;
    icon: React.ComponentType<any>;
    count?: number;
  }>;
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const RapperTabs: React.FC<RapperTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
}) => {
  return (
    <div className="border-b border-gray-700 mb-8">
      <nav className="-mb-px flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
              activeTab === tab.id
                ? "border-blue-500 text-blue-500"
                : "border-transparent text-gray-400 hover:text-gray-300 hover:border-gray-300"
            }`}
          >
            <tab.icon
              className={`-ml-0.5 mr-2 h-5 w-5 ${
                activeTab === tab.id
                  ? "text-blue-500"
                  : "text-gray-400 group-hover:text-gray-300"
              }`}
            />
            {tab.label}
            {tab.count !== undefined && (
              <span
                className={`ml-2 py-0.5 px-2 rounded-full text-xs ${
                  activeTab === tab.id
                    ? "bg-blue-100 text-blue-600"
                    : "bg-gray-800 text-gray-300"
                }`}
              >
                {tab.count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default RapperTabs;
